/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */

import dynamic from "next/dynamic";
import bgImage1 from "/assets/img/location.jpg";
import { robotoSlab } from "/utils/fonts";

const Container = dynamic(() => import("@mui/material/Container"), { loading: () => null });
const Divider = dynamic(() => import("@mui/material/Divider"), { loading: () => null });
const Grid = dynamic(() => import("@mui/material/Grid"), { loading: () => null });

// MUI Icons
const SettingsRounded = dynamic(() => import('@mui/icons-material/SettingsRounded'), { loading: () => null });

// PRO
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

// Parts
const DefaultBackgroundCard = dynamic(() => import('/examples/DefaultBackgroundCard'), { loading: () => null });

function ListItem({ title, children }) {
  return (
    <MDBox p={2}>
      <MDTypography variant="h5" component="h3" mb={1}>
        {title}
      </MDTypography>
      <MDTypography variant="body2" fontWeight="regular">
        {children}
      </MDTypography>
    </MDBox>
  );
}

function LetsStartADiscussion() {
  return (
    <MDBox component="section" pt={12} pb={0}>
      <Container>
        <Grid
          container
          item
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          xs={10}
          lg={5}
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MDBox
            width="3rem"
            height="3rem"
            borderRadius="lg"
            shadow="md"
            variant="gradient"
            bgColor="info"
            color="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <SettingsRounded fontSize="small" sx={{ opacity: 0.8 }} />
          </MDBox>
          <MDTypography variant="h3" component="h2" mt={3} className={robotoSlab.className}>
            LET'S START A DISCUSSION
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Fill out the form below and someone will respond to you within 24 hours.
          </MDTypography>
        </Grid>
        <Grid container spacing={3} alignItems="center" sx={{ mt: 6 }}>
          <Grid item xs={12} md={4} sx={{ ml: "auto" }}>
            <DefaultBackgroundCard
              image={bgImage1}
              label="Autumn Leaf Design Studio"
              title="100 Centershore Rd, Centerport, NY 11721"
              description=""
              action={{
                type: "external",
                route: "https://www.google.com/maps/dir//Autumn+Leaf+Landscape+Design,+100+Centershore+Rd,+Centerport,+NY+11721/@40.8914884,-73.3773813,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89e826770c363025:0x99c88aad47373ab6!2m2!1d-73.3743343!2d40.8922589",
                label: "get directions",
              }}
            />
          </Grid>
          <Grid item xs={12} md={5} sx={{ mr: "auto", ml: { xs: 0, md: 6 } }}>
            <ListItem title="1. By LIE">
              Head West on I-495 W. Take exit 51. Merge onto N Service Rd. Go right onto Deer Pk Ave. Slight left onto Deer Park Rd. Continue onto Park Ave. Turn right onto Broadway/Broadway Greenlawn. Continue onto Centerport Rd. Design Studio on right.
            </ListItem>
            <ListItem title="2. By Northern Blvd">
              Head East on Northen Blvd. Cross New York Ave in Huntington and drive 3.4 miles. Left onto Centershore Rd S. Design Studio on right.
            </ListItem>
            <ListItem title="3. By Northern State Parkway">
              Head East on Northern State Pkwy. Take Exit 41. Go left onto Wolf Hill Rd. Go right onto Old Country Rd. Go Left onto Deer Park Rd. Continue onto Park Ave. Go right onto Broadway/Greenlawn. Continue onto Centerport Rd. Go left onto Centershore Rd S. Design Studio on Right.
            </ListItem>
          </Grid>
        </Grid>
        <Divider sx={{ my: { xs: 2, sm: 8 }, mx: 12 }} />
      </Container>
    </MDBox>
  );
}

export default LetsStartADiscussion;
